export default __webpack_public_path__ + "static/media/adding_manual_transactions.9000aaad.png";